import { render, staticRenderFns } from "./RequestSignature.vue?vue&type=template&id=4c137ac8&"
import script from "./RequestSignature.vue?vue&type=script&lang=js&"
export * from "./RequestSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports